<template>
    <div>
        <div style="padding-bottom:0.35rem;">
          <span class="us_block_title">告警记录</span>
          <span style="font-size: 0.9rem;color: #9e9e9e;" v-if="list.length !== 0">(三天内)</span>
          <span class="us_block_more_text" @click="goList">
            <span>更多</span><i class="fa fa-angle-right" aria-hidden="true"></i>
          </span>
        </div>
        <div v-if="loading" style="margin-top:1rem;">
          <LoadingText />
        </div>
        <div :style="{background:(list.length > 0?'#eee':'#fff')}" v-else>
            <div v-if="list.length > 0">
              <div v-for="(item,index) in list" :key="index">
                <!-- <v-card flat @click="goDetail(item)">
                  <v-list style="font-size:0.9rem;padding-top:0;padding-bottom:0;">
                    <v-list-item class="us-list-item" style="padding:0 0.6rem;position:relative;" >
                      <v-list-item-content>
                          <v-list-item-title style="font-size:0.9rem;padding-top:0.2rem;color:rgba(33, 33, 33, 0.8);">
                            <div style="position:relative;">
                              <span style="margin-right:0.2rem;position:absolute;top:-0.09rem;"><v-icon color="warning" style="font-size:1.05rem;">fa-volume-down</v-icon></span>
                              <div style="margin-left:1rem;">
                                <v-badge class="us-v-badge" color="red accent-2" offset-x="0" offset-y="1" dot v-if="item.READ_SID === 0">
                                  <span>{{item.DEVICE_TEXT}}</span>
                                </v-badge>
                                <span v-else>
                                  <span>{{item.DEVICE_TEXT}}</span>
                                </span>
                                <v-icon color="grey" style="font-size:0.85rem;position:absolute;right:0.1rem;top:0.12rem;">fa fa-angle-right</v-icon>
                              </div>
                            </div>
                          </v-list-item-title>
                          <v-list-item-subtitle style="margin-top:0.2rem;color:rgba(33, 33, 33, 0.8);margin-left:1rem;white-space: normal;line-height:20px;">
                            <span style="color:#9e9e9e;">描述：</span>
                            <span v-if="item.ALERT_TYPE !== 'F'">
                              <span style="color:#F56C6C;">{{item.NOTIFY_CONTENT}}</span>
                              <span v-if="item.alert_info">，<span style="color:#9e9e9e;">当前警报值：</span>{{formatVal(item)}}，
                              <span style="color:#9e9e9e;">时间：</span>{{getMsgTimeFormat(item.alert_info.ALERT_START_DATE)}}，
                              <span style="color:#9e9e9e;">持续时间：</span>{{getDuraStr(item.alert_info.ALERT_DURATION)}}</span>
                            </span>
                            <span v-else>
                              <span style="color:#67C23A;">{{item.NOTIFY_CONTENT}}</span>
                              <span style="color:#67C23A;">【恢复】</span>，
                              <span v-if="item.NOTIFY_CONTENT.indexOf('异常') === -1">
                                <span style="color:#9e9e9e;" >当前恢复值：</span>{{formatVal(item)}}，
                              </span>
                              <span style="color:#9e9e9e;">时间：</span>{{getMsgTimeFormat(item.alert_info.ALERT_START_DATE)}}，
                              <span style="color:#9e9e9e;">持续时间：</span>{{getDuraStr(item.alert_info.ALERT_DURATION)}}
                            </span>
                          </v-list-item-subtitle>
                          <v-list-item-subtitle style="margin-top:0.2rem;color:rgba(33, 33, 33, 0.8);margin-left:1rem;">
                            <span style="color:#9e9e9e;">时间：</span>
                            <span>{{getMsgTimeFormat(item.ROW_DATE_CREATE)}}</span>
                            <span v-if="item.pro_user">
                              <span style="color:#9e9e9e;margin-left:0.7rem;">处理人：</span>
                              <span>{{item.pro_user.name}}</span>
                            </span>
                          </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card> -->
                <!-- <NotifyCard :item="item" flat /> -->
                <NotifyCardF v-if="item.ALERT_TYPE === 'F'" :item="item" flat />
                <NotifyCardT v-else-if="item.ALERT_TYPE === 'T'" :item="item" flat />
                <NotifyCardMsg v-else :item="item" flat />
              </div>
            </div>
            <div v-if="list.length === 0" style="text-align:center;padding:1rem 0;color:#9e9e9e;font-size:0.8rem;">
                三天内暂无警告通知
            </div>
        </div>
    </div>
</template>

<script>
import LoadingText from '../../components/LoadingText'
// import NotifyCard from '../../Biz/Notify/components/NotifyCard.vue'
import NotifyCardF from '../../Biz/Notify/components/NotifyCardF_v3'
import NotifyCardT from '../../Biz/Notify/components/NotifyCardT_v3'
import NotifyCardMsg from '../../Biz/Notify/components/NotifyCardMsg.vue'
export default {
  components: { LoadingText, /* NotifyCard,*/ NotifyCardF, NotifyCardT, NotifyCardMsg },
  props: {
  },
  data() {
    return {
      loading: true,
      list: [],
      pageIndex: 1,
      pageCount: 3,
      hasMore: true,
      timeout: null
    }
  },
  computed: {
  },
  mounted() {
    this.getListTask()
  },
  created() {
  },
  destroyed() {
    var that = this
    if (that.timeout) {
      window.clearTimeout(that.timeout)
    }
  },
  activated() {
    this.getListTask();
  },
  deactivated() {
    var that = this
    if (that.timeout) {
      window.clearTimeout(that.timeout)
    }
  },
  methods: {
    goBack() {
      this.$router.goBack()
    },
    goDetail(item) {
      var that = this
      that.$api.bz.setDeviceNotifyRead({ code: item.NOTIFY_CODE }).then(res => {
        item.READ_SID = 2;
        // that.$router.goPage('/AlertContent/' + item.ALERT_RECORD_CODE + '?has_back=true')
        that.$router.goPage('/AlertContentV3/' + item.NOTIFY_CODE + '?has_back=true')
      })
    },
    getList() {
      var that = this
      that.$api.bz.getDeviceNotifyList({ page_index: that.pageIndex, page_count: that.pageCount, recent: '1' }).then(res => {
        if (!res.success) {
          that.loading = false
          console.log('获取通知列表失败', res);
          return
        }
        var data = res.data
        // console.log(data)
        that.list = data
        // if (data.length == 0) {
        //   that.hasMore = false;
        //   return;
        // }
        // that.hasMore = data.length >= that.pageCount;
        // for (let index = 0; index < data.length; index++) {
        //   const item = data[index];
        //   that.list.push(item);
        // }
        that.loading = false
      })
    },
    // 格式化时间显示
    getMsgTimeFormat(time) {
      var that = this
      var mt = that.$moment(time)
      var tv = mt.format('YYYY-MM-DD')
      var now = that.$moment(new Date()).format('YYYY-MM-DD')
      if (tv < now) {
        var zt = that.$moment(new Date()).add(-1, 'days').format('YYYY-MM-DD')
        if (zt === tv) {
          return mt.format('昨天 HH:mm')
        }
        return mt.format('YYYY-MM-DD HH:mm')
      }
      return mt.format('今天 HH:mm')
    },
    clickLoadMore() {
      var that = this
      that.pageIndex++;
      that.getGzNotifyList();
    },
    goList() {
      this.$router.goPage('/DeviceNotifyList')
    },
    async getListTask() {
      var that = this;
      if (that.timeout) {
        window.clearTimeout(that.timeout);
      }
      await that.getList();
      that.timeout = setTimeout(that.getListTask, 30 * 1000);
    },
    formatVal(item) {
      return item.alert_info.CUR_VALUE.toFixed(item.alert_info.VALIE_DIGITS)
    },
    // 时间格式化
    getDuraStr(sec) {
      var strDura = ''
      var dura = 0
      if (sec >= 86400) {
        dura = Number.parseInt(sec / 60 / 60 / 24);
        strDura = dura + ' 天';
      } else if (sec >= 3600) {
        dura = Number.parseInt(sec / 60 / 60);
        strDura = dura + ' 小时';
      } else if (sec >= 60) {
        dura = Number.parseInt(sec / 60);
        strDura = dura + ' 分钟';
      } else {
        strDura = dura + ' 秒';
      }
      return strDura
    }
  }
}
</script>

<style scoped>
.us-v-badge >>> .v-badge__badge{
  height: 5px !important;
  width: 5px !important;
}

.us-list-item >>> .v-list-item__icon{
  min-width: 0.9rem;
}

.us_block_title{
  font-weight:bold;
  font-size:1.05rem;
  color: rgba(33,33,33,0.9);
}
.us_block_more_text{
  font-size:0.8rem;
  padding-top:0.3rem;
  padding-right:0.4rem;
  float:right;
  color:#9e9e9e;
  cursor: pointer;
}
.us_block_more_text span{
  font-size:0.8rem;
}
.us_block_more_text i{
  margin-left:0.4rem;
}

</style>

